import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const scrollBarVariants = tv({
  base: "flex touch-none p-px transition-colors select-none",
  variants: {
    orientation: {
      vertical: "h-full w-2.5 border-l border-l-transparent",
      horizontal: "h-2.5 flex-col border-t border-t-transparent"
    }
  },
  defaultVariants: {
    orientation: "vertical"
  }
});
export {
  scrollBarVariants
};
//# sourceMappingURL=index.js.map
